var map = {
	"./en/account.json": 5399,
	"./en/auth.json": 7212,
	"./en/common.json": 8419,
	"./en/error.json": 4522,
	"./en/modal.json": 5421,
	"./en/popover.json": 6341,
	"./vi/account.json": 1169,
	"./vi/auth.json": 322,
	"./vi/common.json": 6953,
	"./vi/error.json": 28,
	"./vi/modal.json": 5611,
	"./vi/popover.json": 9095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1061;